import {Directive, Output, HostListener, EventEmitter} from '@angular/core';
import { Store } from '@ngrx/store';
import { IAppState } from '../app.state';
import {Config} from '../universal-config';
import { logoutUser } from '../profile/profile.actions';

@Directive({
  selector: '[clickLogout]'
})
export class ClickLogoutDirective {
  constructor(
    public _config: Config,
    public _store: Store<IAppState>
  ) {
  }

  @HostListener('click', ['$event'])
  onClick(event) {
    this._store.dispatch(logoutUser());
    document.cookie = 'eversessionid=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/';
  }
}
